import AnalysisService from '@/services/analysis.service';
import { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';

interface IAnalysis {
  numberOfLogin: number;
  time: string
}

const options: ApexCharts.ApexOptions = {
  chart: {
    type: 'line',
    zoom: {
      enabled: true,
      type: 'x',
      autoScaleYaxis: true,
    },
    toolbar: {
      autoSelected: 'zoom',
    },
  },
  stroke: {
    curve: 'smooth'
  },
  xaxis: {
    type: 'category',
    title: {
      text: 'Date'
    }
  },
  yaxis: {
    min: 0,
    forceNiceScale: true,
    labels: {
      formatter: (val) => val.toFixed(0)
    },
    title: {
      text: 'Number of Login'
    }
  },
  tooltip: {
    x: {
      format: 'dd/MM/yyyy'
    }
  }
};

export default function AnalysisChart() {
  const [analysisLogin, setAnalysisLogin] = useState<IAnalysis[]>([]);

  useEffect(() => {
    fetchAnalysis();
  }, []);

  const fetchAnalysis = async () => {
    try {
      const response = await AnalysisService.analysisStatistics();
      setAnalysisLogin(response.data.analysises || []);
    } catch (err) {
      console.error("Error fetching flashcards:", err);
    }
  };


  return (
    <div>
      <div className="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] md:p-6">
        <div className="w-full">
          <ReactApexChart
            options={options}
            series={[
              {
                name: "Number of Login",
                data: analysisLogin.map(item => ({
                  x: new Date(item.time).toLocaleDateString('en-GB'),
                  y: item.numberOfLogin,
                })),
              },
            ]}
            type="line"
            height={350}
          />
        </div>
      </div>
    </div>

  );
}
